var cube = require('./cube');

// Event
(function(cube) {
  var Pubsub = function() {
    this.__callbacks__ = {};
  };

  cube.mix(Pubsub.prototype, {
    on: function(name, callback, context) {
      if (context) {
        callback = cube.bind(callback, context);
      }

      var arr = this.__callbacks__[name];
      if (arr && arr.fired === true){
        callback.apply(context, arr.args);
        return;
      }

      // for fireReady

      this.__callbacks__[name] = this.__callbacks__[name] || [];
      this.__callbacks__[name].push(callback);

      return [ name, callback ];
    },

    un: function(handle) {
      var name = handle[0];
      var callback = handle[1];

      if (name in this.__callbacks__) {
        var callbacks = this.__callbacks__[name];
        cube.forEach(callbacks, function(cb, i) {
          if (callback == cb) {
            callbacks[i] = null;
          }
        });
      }
    },

    once: function(name, callback, context) {
      var me = this;
      var handle = this.on(name, function() {
        callback.apply(context, arguments);
        me.un(handle);
      });
    },

    fire: function(name/* args */) {
      if (name in this.__callbacks__) {
        var callbacks = this.__callbacks__[name];
        var args = Array.prototype.slice.call(arguments, 1);
        cube.forEach(callbacks, function(callback, i) {
          if (typeof(callback) != "function") {
            return null;
          }
          return callback.apply(null, args);
        });
      }
    },

    /**
    * if the event has been fired, the callback on this event will still be executed.
    */
    fireReady: function(name/* args */){
      var callbacks = this.__callbacks__[name];
      if (!callbacks){
        callbacks = this.__callbacks__[name] = [];
      }
      var args = Array.prototype.slice.call(arguments, 1);
      cube.forEach(callbacks, function(callback, i) {
        if (typeof(callback) != "function") {
          return null;
        }
        return callback.apply(null, args);
      });
      callbacks.fired = true;
      callbacks.args = args;
    }
  });

  cube.Pubsub = Pubsub;
  cube.mix(cube, (new Pubsub()));

})(cube);



//////////////////
// WEBPACK FOOTER
// ./src/js/~/cube-event.js
// module id = 36
// module chunks = 1